import { Form } from 'react-bootstrap';
import { joinLabeledValue } from '../../utils/joinLabeledValue';
import {
  normalizeDateToYYYYMMDD,
  type DateRangeDirection,
  type DateRangeUnit,
} from '../../utils/sampleDateRange';

/** 単位選択肢：日（デフォルト）・週・月・年 */
const DATE_UNITS: readonly DateRangeUnit[] = ['day', 'week', 'month', 'year'];

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export type SampleDateRangeFilterRowProps = {
  dateValue: string;
  dateOnChange: (v: string | undefined) => void;
  dirValue: DateRangeDirection;
  dirOnChange: (v: DateRangeDirection) => void;
  valValue: number | undefined;
  valOnChange: (v: number | undefined) => void;
  unitValue: DateRangeUnit;
  unitOnChange: (v: DateRangeUnit) => void;
  dateLabelKey: string;
  t: TranslateFn;
  language: string;
};

/** 日付＋前後○日フィルター1行（ラベル縦積みをやめ、タイトル＋横並びコントロール） */
export default function SampleDateRangeFilterRow({
  dateValue,
  dateOnChange,
  dirValue,
  dirOnChange,
  valValue,
  valOnChange,
  unitValue,
  unitOnChange,
  dateLabelKey,
  t,
  language,
}: SampleDateRangeFilterRowProps) {
  const dateLabel = t(dateLabelKey);
  return (
    <div className="sample-date-range-row">
      <span className="sample-date-range-title">{dateLabel}</span>
      <Form.Control
        type="date"
        className="form-control-sm sample-date-range-date"
        value={normalizeDateToYYYYMMDD(dateValue)}
        onChange={(e) => dateOnChange(e.target.value || undefined)}
        autoComplete="off"
        lang={language}
        aria-label={dateLabel}
      />
      <Form.Select
        size="sm"
        className="sample-date-range-dir"
        value={dirValue}
        onChange={(e) => dirOnChange(e.target.value as DateRangeDirection)}
        aria-label={joinLabeledValue(dateLabel, t('sample_filter.date_range_label'))}
      >
        <option value="before">{t('sample_filter.date_direction_before')}</option>
        <option value="after">{t('sample_filter.date_direction_after')}</option>
        <option value="both">{t('sample_filter.date_direction_both')}</option>
      </Form.Select>
      <Form.Control
        type="number"
        size="sm"
        className="sample-date-range-val"
        min={0}
        placeholder={t('sample_filter.date_value_placeholder')}
        value={valValue ?? ''}
        onChange={(e) => {
          const raw = e.target.value;
          valOnChange(raw === '' ? undefined : Math.max(0, parseInt(raw, 10) || 0));
        }}
        autoComplete="off"
        aria-label={joinLabeledValue(dateLabel, t('sample_filter.date_value_label'))}
      />
      <Form.Select
        size="sm"
        className="sample-date-range-unit"
        value={unitValue}
        onChange={(e) => unitOnChange(e.target.value as DateRangeUnit)}
        aria-label={joinLabeledValue(dateLabel, t('sample_filter.unit_label'))}
      >
        {DATE_UNITS.map((u) => (
          <option key={u} value={u}>
            {t(`sample_filter.date_unit_${u}`)}
          </option>
        ))}
      </Form.Select>
    </div>
  );
}
